(function () {
  function _uncs_initImageBannerSlider(slider) {
    if (slider.dataset.uncsTapToScrollInit) return;
    slider.dataset.uncsTapToScrollInit = "true";

    slider.addEventListener("click", function (event) {
      if (!window.matchMedia("(max-width: 989px)").matches) return;
      if (slider.scrollWidth <= slider.clientWidth) return;

      var slides = slider.querySelectorAll(".image-banner-slider__slide");
      if (slides.length < 2) return;

      var slide = event.target.closest(".image-banner-slider__slide");
      if (!slide || !slider.contains(slide)) return;

      var center = slider.scrollLeft + slider.clientWidth / 2;
      var current = slides[0];
      var minDist = Infinity;
      slides.forEach(function (s) {
        var dist = Math.abs(s.offsetLeft + s.clientWidth / 2 - center);
        if (dist < minDist) {
          minDist = dist;
          current = s;
        }
      });

      if (slide === current) return;

      event.preventDefault();
      event.stopPropagation();

      var sliderStyle = window.getComputedStyle(slider);
      var padStart = parseFloat(sliderStyle.scrollPaddingInlineStart) || 0;
      var padEnd = parseFloat(sliderStyle.scrollPaddingInlineEnd) || 0;
      var align = window.getComputedStyle(slide).scrollSnapAlign.split(/\s+/).pop();
      var targetLeft;
      if (align === "start") {
        targetLeft = slide.offsetLeft - padStart;
      } else if (align === "end") {
        targetLeft = slide.offsetLeft + slide.clientWidth - slider.clientWidth + padEnd;
      } else {
        targetLeft = slide.offsetLeft - (slider.clientWidth - slide.clientWidth) / 2;
      }

      slider.scrollTo({ left: targetLeft, behavior: "smooth" });
    });
  }

  function _uncs_initAllImageBannerSliders(root) {
    (root || document)
      .querySelectorAll(".image-banner-slider__content")
      .forEach(_uncs_initImageBannerSlider);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      _uncs_initAllImageBannerSliders();
    });
  } else {
    _uncs_initAllImageBannerSliders();
  }

  document.addEventListener("shopify:section:load", function (event) {
    _uncs_initAllImageBannerSliders(event.target);
  });
})();
